// extracted by mini-css-extract-plugin
export default {"Container":"planning_Container__W4lm1","section-1":"planning_section-1__Og0Ui","content":"planning_content__SCmTv","section-2":"planning_section-2__hacBR"};